import { Card, Checkbox, Col, Divider, Form, InputNumber, Row, Select, Switch, TimePicker } from 'antd';
import React, { useEffect, useState } from 'react';
import StepNoItem from '../../../helpers/components/step_no_item';
import otherService from '../../../services/config/other.service';

const BasicConfiguration = ({ form, park, }) => {
    const [state, setState] = useState({
        loading : false,
        currencies : [],
        payment_gateways : [],
        purchase_types : [],
        park: park,
    })

    const [selected, setSelected] = useState({
        currency : null,
    })

    const fetchCurrency = async () => {
        const currencyResponse = await otherService?.getCurrency();

        const { currencies, } = currencyResponse;
        return currencies;
    }

    const fetchPaymentGateway = async () => {
        const paymentGatewayResponse = await otherService?.getPaymentGateway();
        const { payment_gateways } = paymentGatewayResponse;
        const filtered_gateways = payment_gateways?.filter(gateway => !gateway.is_ewallet) || [];
        return filtered_gateways;
    }

    const fetchPurchaseTypes = async () => {
        const purchaseTypeResponse = await otherService?.getPurchaseTypes({
            is_capacity : 1,
        });
        const { purchase_types, } = purchaseTypeResponse;
        return purchase_types;
    }

    const handleKeyPress = (e) => {
        const key = e.key;
        const value = e.target.value;
        
        // Allow: numbers (0-9), decimal point (.), Backspace, Delete, Tab, Arrow keys
        const allowedKeys = ['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'];
        
        // Check if key is allowed
        if (allowedKeys.includes(key)) {
            return; // Allow these keys
        }
        
        // Allow numbers 0-9
        if (key >= '0' && key <= '9') {
            return; // Allow numbers
        }
        
        // Allow decimal point, but only one
        if (key === '.') {
            if (value.includes('.')) {
                e.preventDefault(); // Already has a decimal point
            }
            return;
        }
        
        // Block all other keys (including letters)
        e.preventDefault();
    };

    useEffect(() => {
        const initialize = async () => {
            if(park){
                setState(state => ({...state, loading : true, }));
                const currencies = await fetchCurrency();
                const payment_gateways = await fetchPaymentGateway();
                const purchase_types = await fetchPurchaseTypes();

                setState(state => ({...state, loading : false, currencies : currencies, payment_gateways : payment_gateways, purchase_types : purchase_types, }));
                setSelected(selected => ({...selected, currency : park?.currency_id}));
            }
        }

        initialize();
    }, [park]);

    const currencyCode = state?.currencies?.find(x => x.currency_id === selected?.currency)?.code || 'MYR';

    return (
        <>
            <Card
            styles={{ header : { padding : 12, } }}
            title={(
                <>
                    <div style={{textAlign : 'start', }}>
                        <StepNoItem no={3} text={'Configuration'} />
                    </div>
                </>
            )}
            >
                <div>
                    <div>
                        <div style={{ textAlign : 'start', }}>
                            <span style={{ fontSize : 16, fontWeight : 500, }}>Payment Configuration</span>
                        </div>
                        <div style={{ marginTop: 12, }}>
                            <Row gutter={[12, 12]}>
                                <Col span={12}>
                                    <Form.Item label={'Payment Gateway'} name={'payment_gateway'} style={{textAlign:'start',}}>
                                        <Select
                                        options={state?.payment_gateways?.map(payment_gateway => ({ label : payment_gateway?.name, value : payment_gateway?.payment_gateway_id, }))}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item extra={(
                                        <>
                                            <div style={{ textAlign : 'start', }}>
                                                <span>Display purpose, does not associate with payment gateway</span>
                                            </div>
                                        </>
                                    )} label={'Currency'} name={'currency'}>
                                        <Select
                                        // removeIcon
                                        onChange={(currency_id) => setSelected(selected => ({...selected, currency : (currency_id)}))}
                                        options={state?.currencies?.map(currency => ({ label : currency?.name, value : currency?.currency_id, }))}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label={'Date Change Price'} name={'date_change_price'}>
                                        <InputNumber min={0} addonBefore={ state?.currencies?.find(x => x.currency_id === selected?.currency)?.code } precision={2} style={{ width : '100%', }} />
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                
                                </Col>
                            </Row>
                        </div>
                    </div>
                    <Divider style={{ marginBlock : 12, }} />
                    <div>
                        <div style={{ textAlign : 'start', }}>
                            <span style={{ fontSize : 16, fontWeight : 500, }}>Pay with Melon</span>
                        </div>
                        <div style={{ marginTop: 12, }}>
                            <Row gutter={[12, 12]}>
                                <Col span={12}>
                                    <Form.Item
                                        valuePropName="checked"
                                        style={{ textAlign : 'start', }}
                                        label={'Enable pay with Cool Melon Ewallet'}
                                        name={'enable_pay_with_ewallet'}
                                        extra={'Allow customers to pay using Cool Melon e-wallet credits'}
                                    >
                                        <Switch />
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item 
                                        label={'Melon Exchange Rate'} 
                                        name={'melon_exchange_rate'}
                                        extra={(
                                            <div style={{ textAlign: 'start' }}>
                                                <span>
                                                    1 {currencyCode} = X Melon credits. 
                                                    E.g., if 1 {currencyCode} = 100 Melon, enter 100
                                                </span>
                                            </div>
                                        )}
                                    >
                                        <InputNumber 
                                            min={0}
                                            max={999999.99}
                                            precision={2}
                                            placeholder="Enter exchange rate" 
                                            style={{ width: '100%' }}
                                            addonAfter="Melon credits"
                                            controls={true}
                                            keyboard={true}
                                            stringMode={false}
                                            step={1}
                                            parser={value => value.replace(/[^\d.]/g, '')}
                                            onKeyDown={handleKeyPress}
                                            className="always-show-controls"
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </div>
                    </div>
                    <Divider style={{ marginBlock : 12, }} />
                    <div>
                        <div style={{ textAlign : 'start', }}>
                            <span style={{ fontSize : 16, fontWeight : 500, }}>Others</span>
                        </div>
                        <div style={{ marginTop: 12, }}>
                            <Row gutter={[12, 12]}>
                                <Col span={12}>
                                    <Form.Item extra={(
                                        <>
                                            <div style={{textAlign : 'start',}}>
                                                <span>Ticket capacity for park</span>
                                            </div>
                                        </>
                                    )} label={'Capacity'} name={'capacity'}>
                                        <InputNumber min={0} precision={0} style={{ width : '100%', }}/>
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label={'Capacity applies to'} name={'purchase_type_capacities'} style={{ textAlign : 'start', }}>
                                        <Checkbox.Group options={state?.purchase_types?.map((purchase_type, index) => {
                                            const { purchase_type_id, name, } = purchase_type ?? {};
                                            return {
                                                label : name,
                                                value : purchase_type_id,
                                            }
                                        })}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item
                                    valuePropName="checked"
                                    style={{ textAlign : 'start', }}
                                    label={'Required User Detail'}
                                    name={'is_user_detail_required'}
                                    extra={"Name, gender and age required when activities uploading selfies"}
                                    >
                                        <Switch />
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item
                                        style={{ textAlign: 'start', }}
                                        label={'Cut Off Time'}
                                        name={'ticket_cut_off_time'}
                                        extra={"The latest time each day when tickets can be purchased. After this time, same-day ticket purchases will be disabled."}
                                    >
                                        <TimePicker
                                            format="HH:mm"         // only hours:minutes
                                            showSecond={false}     // hide seconds
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </div>
            </Card>
        </>
    );
}

export default BasicConfiguration;
